import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Apiurl from "../environment/Apiurl";

function UpdatePatients() {
  const [currentPage, setCurrentPage] = useState(1);
  const [errors, setErrors] = useState({});
  const [patientType, setPatientType] = useState("");
  const [responseStaffData, setResponseStaffData] = useState([]);
  const [responseDoctorData, setResponseDoctorData] = useState([]);
  const [referredByOptions, setReferredByOptions] = useState([]);
  const [addData, setAddData] = useState({
    patient_id: "",
    registration_date: "",
    first_name: "",
    last_name: "",
    age: "",
    date_of_birth: "",
    gender: "",
    marital_status: "",
    spouse_name: "",
    mobile_no: "",
    email: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    id_proof_type: "",
    id_proof_no: "",
    notes: "",
    purpose: "",
    referred_by: "",
    referred_by_name: "",
    referred_by_mobile: "",
    patient_type: "",
    married_for_year: "",
    type_of_yoga: "",
    consiquence: "",
    menstrual: "",
    sexual_histroy: "",
    medical_histroy: "",
    previous_histroy: "",
    family_histroy: "",
    current_mediatation: "",
    height_cm: "",
    weight_kg: "",
    blood_group: "",
    bp_level: "",
    sugar_level: "",
    pluse: "",
    breast: "",
    tyroid: "",
    per_abutamon: "",
    per_speculum: "",
    per_virginal_exam: "",
    scan_findings: "",
    diagonsis: "",
    plan_of_treatment: "",
    advise: "",
    next_review_date: "",
    siemen_analysis: "",
    homeo_bp: "",
    homeo_sugar: "",
    homeo_height: "",
    homeo_heart_rate: "",
    homeo_blood_test: "",
    homeo_electriohomeogram: "",
    homeo_stress_test: "",
    homeo_echohomeogram: "",
    homeo_scan_type: "",
  });

  const [errorMessage, setErrorMessage] = useState({});

  const navigate = useNavigate();
  const location = useLocation();
  const patient = location.state?.patient;

  const fetchStaffData = async () => {
    try {
      const response = await axios.get(`${Apiurl}/staff`);
      console.log("Response from setResponseStaffData:", response.data);
      setResponseStaffData(response.data);
    } catch (error) {
      console.error("Error fetching staff data:", error.message);
    }
  };

  const fetchDoctorData = async () => {
    try {
      const response = await axios.get(`${Apiurl}/doctor`);
      console.log("Response from setResponseDoctorData:", response.data);
      setResponseDoctorData(response.data);
    } catch (error) {
      console.error("Error fetching doctor data:", error.message);
    }
  };
    useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    fetchStaffData();
    fetchDoctorData();
    if (patient) {
      setAddData({
        ...addData,
        ...patient,
        patient_type: patient.patient_type || "",
        referred_by: patient.referred_by || "",
        referred_by_name: patient.referred_by_name || "",
        referred_by_mobile: patient.referred_by_mobile || "",
      });
      setPatientType(patient.patient_type || "");
      if (patient.referred_by === "Staff") {
        setReferredByOptions(responseStaffData);
      } else if (patient.referred_by === "Doctor") {
        setReferredByOptions(responseDoctorData);
      }
    } else {
      navigate("/patients/homeopathy-patients");
    }
  }, [patient, navigate]);

  useEffect(() => {
    if (patient && patient.referred_by) {
      setReferredByOptions(
        patient.referred_by === "Staff"
          ? responseStaffData
          : patient.referred_by === "Doctor"
          ? responseDoctorData
          : []
      );
    }
  }, [responseStaffData, responseDoctorData, patient]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "patient_type") {
      setPatientType(value);
    }
    if (name === "referred_by") {
      setAddData((prev) => ({
        ...prev,
        referred_by: value,
        referred_by_name: "",
        referred_by_mobile: "",
      }));
      setReferredByOptions(
        value === "Staff"
          ? responseStaffData
          : value === "Doctor"
          ? responseDoctorData
          : []
      );
    } else {
      setAddData((prev) => ({ ...prev, [name]: value }));
    }
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleReferredBySelection = (e) => {
    const value = e.target.value;
    if (addData.referred_by === "Staff") {
      const selectedStaff = responseStaffData.find(
        (staff) => staff.staff_id === value
      );
      if (selectedStaff) {
        setAddData((prev) => ({
          ...prev,
          referred_by_name: `${selectedStaff.first_name} ${selectedStaff.last_name}`,
          referred_by_mobile: selectedStaff.mobile_no,
        }));
      }
    } else if (addData.referred_by === "Doctor") {
      const selectedDoctor = responseDoctorData.find(
        (doctor) => doctor.doctor_id === value
      );
      if (selectedDoctor) {
        setAddData((prev) => ({
          ...prev,
          referred_by_name: selectedDoctor.doctor_name,
          referred_by_mobile: selectedDoctor.mobile_no,
        }));
      }
    }
  };

  const handleDateOfBirthChange = (e) => {
    const dob = e.target.value;
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    setAddData({
      ...addData,
      date_of_birth: dob,
      age: age.toString(),
    });
  };

  const handleNext = () => {
    const newErrors = {};
    if (!addData.registration_date)
      newErrors.registration_date = "* Registration date is required";
    if (!addData.first_name) newErrors.first_name = "* First name is required";
    if (!addData.last_name) newErrors.last_name = "* Last name is required";
    if (!addData.date_of_birth)
      newErrors.date_of_birth = "* Date of birth is required";
    if (!addData.gender) newErrors.gender = "* Gender is required";
    if (!addData.marital_status)
      newErrors.marital_status = "* Marital status is required";
    if (!addData.mobile_no) newErrors.mobile_no = "* Mobile number is required";

    if (Object.keys(newErrors).length > 0) {
      setErrorMessage(newErrors);
      return;
    }

    setCurrentPage((prev) => prev + 1);
  };

  const handleBack = () => {
    setCurrentPage((prev) => prev - 1);
  };

  const handleCancel = () => {
    if (addData.patient_type === "Yoga") {
      navigate("/patients/yoga-patients");
    } else if (addData.patient_type === "Homeopathy") {
      navigate("/patients/homeopathy-patients");
    } else {
    }
  };

  const handleSubmit = async () => {
    try {
      const formData = { ...addData };
      console.log("Updating:", formData);

      const response = await axios.put(
        `${Apiurl}/patient_details/${patient._id}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Response:", response.data);

      if (formData.patient_type === "Yoga") {
        navigate("/patients/yoga-patients");
      } else if (formData.patient_type === "Homeopathy") {
        navigate("/patients/homeopathy-patients");
      } else {
        // Default fallback or handle other types
        navigate("/patients");
      }
    } catch (error) {
      console.error("Update Error:", error.response?.data || error.message);
      setErrors((prev) => ({
        ...prev,
        submit: error.response?.data?.message || "Failed to update patient",
      }));
    }
  };

  const getFieldClass = (fieldName) => {
    return `form-control ${errors[fieldName] ? "is-invalid" : ""}`;
  };

  const getSelectClass = (fieldName) => {
    return `form-select ${errors[fieldName] ? "is-invalid" : ""}`;
  };

  const renderStep1 = () => (
    <div className="row g-3">
      <h2
        className="text-center text-white p-2"
        style={{ backgroundColor: "#01AEBE" }}
      >
        Basic Details
      </h2>
      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Patient ID</label>
        <input
          type="text"
          name="patient_id"
          className={getFieldClass("patient_id")}
          placeholder="Enter Patient ID"
          value={addData.patient_id}
          onChange={handleInputChange}
          readOnly

          // readOnly
        />
        {errors.patient_id && (
          <div className="invalid-feedback">{errors.patient_id}</div>
        )}
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Registration Date</label>
        <input
          type="date"
          name="registration_date"
          className={getFieldClass("registration_date")}
          value={addData.registration_date}
          onChange={handleInputChange}
        />
        {errorMessage.registration_date && (
          <div className="text-danger" style={{ marginTop: "-15px" }}>
            {errorMessage.registration_date}
          </div>
        )}
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">First Name</label>
        <input
          type="text"
          name="first_name"
          className={getFieldClass("first_name")}
          placeholder="Enter First Name"
          value={addData.first_name}
          onChange={handleInputChange}
        />
        {errorMessage.first_name && (
          <div className="text-danger" style={{ marginTop: "-15px" }}>
            {errorMessage.first_name}
          </div>
        )}
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Last Name</label>
        <input
          type="text"
          name="last_name"
          className={getFieldClass("last_name")}
          placeholder="Enter Last Name"
          value={addData.last_name}
          onChange={handleInputChange}
        />
        {errorMessage.last_name && (
          <div className="text-danger" style={{ marginTop: "-15px" }}>
            {errorMessage.last_name}
          </div>
        )}
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Date of Birth</label>
        <input
          type="date"
          name="date_of_birth"
          className={getFieldClass("date_of_birth")}
          value={addData.date_of_birth}
          onChange={handleDateOfBirthChange}
        />
        {errorMessage.date_of_birth && (
          <div className="text-danger" style={{ marginTop: "-15px" }}>
            {errorMessage.date_of_birth}
          </div>
        )}
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Age</label>
        <input
          type="number"
          name="age"
          className={getFieldClass("age")}
          placeholder="Enter Age"
          value={addData.age}
          readOnly
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Gender</label>
        <select
          name="gender"
          className={getSelectClass("gender")}
          value={addData.gender}
          onChange={handleInputChange}
        >
          <option value="">Select Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          <option value="Other">Other</option>
        </select>
        {errorMessage.gender && (
          <div className="text-danger">{errorMessage.gender}</div>
        )}
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Marital Status</label>
        <select
          name="marital_status"
          className={getSelectClass("marital_status")}
          value={addData.marital_status}
          onChange={handleInputChange}
        >
          <option value="">Select Marital Status</option>
          <option value="Single">Single</option>
          <option value="Married">Married</option>
          <option value="Divorced">Divorced</option>
          <option value="Widowed">Widowed</option>
        </select>
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">
          Spouse Name / Father's Name
        </label>
        <input
          type="text"
          name="spouse_name"
          className={getFieldClass("spouse_name")}
          placeholder="Enter Spouse Name / Father's Name"
          value={addData.spouse_name}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Mobile Number</label>
        <input
          type="tel"
          name="mobile_no"
          className={getFieldClass("mobile_no")}
          placeholder="Enter Mobile Number"
          value={addData.mobile_no}
          onChange={handleInputChange}
          maxLength="10"
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Email</label>
        <input
          type="email"
          name="email"
          className={getFieldClass("email")}
          placeholder="Enter Email"
          value={addData.email}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Address</label>
        <input
          type="text"
          name="address"
          className={getFieldClass("address")}
          placeholder="Enter Address"
          value={addData.address}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">City</label>
        <input
          type="text"
          name="city"
          className={getFieldClass("city")}
          placeholder="Enter City"
          value={addData.city}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">State</label>
        <select
          name="state"
          className={getSelectClass("state")}
          value={addData.state}
          onChange={handleInputChange}
        >
          <option value="">Select State</option>
          <option value="Andhra Pradesh">Andhra Pradesh</option>
          <option value="Arunachal Pradesh">Arunachal Pradesh</option>
          <option value="Assam">Assam</option>
          <option value="Bihar">Bihar</option>
          <option value="Chhattisgarh">Chhattisgarh</option>
          <option value="Goa">Goa</option>
          <option value="Gujarat">Gujarat</option>
          <option value="Haryana">Haryana</option>
          <option value="Himachal Pradesh">Himachal Pradesh</option>
          <option value="Jharkhand">Jharkhand</option>
          <option value="Karnataka">Karnataka</option>
          <option value="Kerala">Kerala</option>
          <option value="Madhya Pradesh">Madhya Pradesh</option>
          <option value="Maharashtra">Maharashtra</option>
          <option value="Manipur">Manipur</option>
          <option value="Meghalaya">Meghalaya</option>
          <option value="Mizoram">Mizoram</option>
          <option value="Nagaland">Nagaland</option>
          <option value="Odisha">Odisha</option>
          <option value="Punjab">Punjab</option>
          <option value="Rajasthan">Rajasthan</option>
          <option value="Sikkim">Sikkim</option>
          <option value="Tamil Nadu">Tamil Nadu</option>
          <option value="Telangana">Telangana</option>
          <option value="Tripura">Tripura</option>
          <option value="Uttar Pradesh">Uttar Pradesh</option>
          <option value="Uttarakhand">Uttarakhand</option>
          <option value="West Bengal">West Bengal</option>
          <option value="Delhi">Delhi</option>
          <option value="Jammu and Kashmir">Jammu and Kashmir</option>
          <option value="Ladakh">Ladakh</option>
          <option value="Puducherry">Puducherry</option>
          <option value="Other">Other</option>
        </select>
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Pincode</label>
        <input
          type="text"
          name="pincode"
          className={getFieldClass("pincode")}
          placeholder="Enter Pincode"
          value={addData.pincode}
          onChange={handleInputChange}
          maxLength="6"
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">ID Proof Type</label>
        <select
          name="id_proof_type"
          className={getSelectClass("id_proof_type")}
          value={addData.id_proof_type}
          onChange={handleInputChange}
        >
          <option value="">Select ID Proof Type</option>
          <option value="Aadhaar">Aadhaar</option>
          <option value="PAN">PAN</option>
          <option value="Voter ID">Voter ID</option>
          <option value="Driving License">Driving License</option>
          <option value="Passport">Passport</option>
        </select>
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">ID Proof Number</label>
        <input
          type="text"
          name="id_proof_no"
          className={getFieldClass("id_proof_no")}
          placeholder="Enter ID Proof Number"
          value={addData.id_proof_no}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Notes</label>
        <textarea
          name="notes"
          className={getFieldClass("notes")}
          placeholder="Enter Notes"
          rows="2"
          value={addData.notes}
          onChange={handleInputChange}
        ></textarea>
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Purpose</label>
        <textarea
          name="purpose"
          className={getFieldClass("purpose")}
          placeholder="Enter Purpose"
          rows="2"
          value={addData.purpose}
          onChange={handleInputChange}
        ></textarea>
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Referred By</label>
        <select
          name="referred_by"
          className={getSelectClass("referred_by")}
          value={addData.referred_by}
          onChange={handleInputChange}
        >
          <option value="">Select Referred By</option>
          <option value="Staff">Staff</option>
          <option value="Doctor">Doctor</option>
          <option value="Others">Others</option>
        </select>
      </div>

      {addData.referred_by === "Staff" || addData.referred_by === "Doctor" ? (
        <div className="col-12 col-md-4">
          <label className="form-label fw-semibold">Select Referred By</label>
          <select
            name="referred_by_select"
            className={getSelectClass("referred_by_select")}
            onChange={handleReferredBySelection}
          >
            <option value="">Select {addData.referred_by}</option>
            {referredByOptions.map((option) => (
              <option
                key={option.staff_id || option.doctor_id}
                value={option.staff_id || option.doctor_id}
              >
                {option.staff_id
                  ? `${option.staff_id} - ${option.first_name} ${option.last_name}`
                  : `${option.doctor_id} - ${option.doctor_name}`}
              </option>
            ))}
          </select>
        </div>
      ) : null}

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Referred Name</label>
        <input
          type="text"
          name="referred_by_name"
          className={getFieldClass("referred_by_name")}
          placeholder="Enter Referred Name"
          value={addData.referred_by_name}
          onChange={handleInputChange}
          readOnly={
            addData.referred_by === "Staff" || addData.referred_by === "Doctor"
          }
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Referred Mobile</label>
        <input
          type="text"
          name="referred_by_mobile"
          className={getFieldClass("referred_by_mobile")}
          placeholder="Enter Referred Mobile"
          value={addData.referred_by_mobile}
          onChange={handleInputChange}
          readOnly={
            addData.referred_by === "Staff" || addData.referred_by === "Doctor"
          }
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Patient Type</label>
        <select
          name="patient_type"
          className={getSelectClass("patient_type")}
          value={addData.patient_type}
          onChange={handleInputChange}
          readOnly
          disabled
        >
          <option value="">Select Patient Type</option>
          <option value="Yoga">Yoga</option>
          <option value="Homeopathy">Homeopathy</option>
        </select>
      </div>

      <div className="text-center mt-4">
        <button
          type="button"
          className="btn btn-secondary me-3 px-4 py-2"
          onClick={handleCancel}
        >
          Cancel
        </button>
        {patientType && (
          <button
            type="button"
            className="btn btn-info text-white fw-semibold px-4 py-2"
            style={{ backgroundColor: "#01AEBE" }}
            onClick={handleNext}
          >
            Next
          </button>
        )}
      </div>
    </div>
  );

  const renderYogaStep2 = () => (
    <div className="row g-3">
      <h2
        className="text-center text-white p-2"
        style={{ backgroundColor: "#01AEBE" }}
      >
        Yoga
      </h2>
      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Married For (Years)</label>
        <input
          type="text"
          name="married_for_year"
          className={getFieldClass("married_for_year")}
          placeholder="Enter Years Married"
          value={addData.married_for_year}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Type of Yoga</label>
        <select
          name="type_of_yoga"
          className={getSelectClass("type_of_yoga")}
          value={addData.type_of_yoga}
          onChange={handleInputChange}
        >
          <option value="">Select Yoga</option>
          <option value="Primary">Primary</option>
          <option value="Secondary">Secondary</option>
        </select>
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Consanguinity</label>
        <input
          type="text"
          name="consiquence"
          className={getFieldClass("consiquence")}
          placeholder="Enter Consanguinity"
          value={addData.consiquence}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Menstrual</label>
        <select
          name="menstrual"
          className={getSelectClass("menstrual")}
          value={addData.menstrual}
          onChange={handleInputChange}
        >
          <option value="">Select Menstrual Status</option>
          <option value="Regular">Regular</option>
          <option value="Irregular">Irregular</option>
          <option value="Absent">Absent</option>
        </select>
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Sexual History</label>
        <textarea
          name="sexual_histroy"
          className={getFieldClass("sexual_histroy")}
          placeholder="Enter Sexual History"
          rows="2"
          value={addData.sexual_histroy}
          onChange={handleInputChange}
        ></textarea>
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Medical History</label>
        <textarea
          name="medical_histroy"
          className={getFieldClass("medical_histroy")}
          placeholder="Enter Medical History"
          rows="2"
          value={addData.medical_histroy}
          onChange={handleInputChange}
        ></textarea>
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Previous History</label>
        <textarea
          name="previous_histroy"
          className={getFieldClass("previous_histroy")}
          placeholder="Enter Previous History"
          rows="2"
          value={addData.previous_histroy}
          onChange={handleInputChange}
        ></textarea>
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Family History</label>
        <textarea
          name="family_histroy"
          className={getFieldClass("family_histroy")}
          placeholder="Enter Family History"
          rows="2"
          value={addData.family_histroy}
          onChange={handleInputChange}
        ></textarea>
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Current Medication</label>
        <textarea
          name="current_mediatation"
          className={getFieldClass("current_mediatation")}
          placeholder="Enter Current Medication"
          rows="2"
          value={addData.current_mediatation}
          onChange={handleInputChange}
        ></textarea>
      </div>

      <div className="text-center mt-4">
        <button
          type="button"
          className="btn btn-secondary me-3 px-4 py-2"
          onClick={handleBack}
        >
          Back
        </button>
        <button
          type="button"
          className="btn btn-info text-white fw-semibold px-4 py-2"
          style={{ backgroundColor: "#01AEBE" }}
          onClick={handleNext}
        >
          Next
        </button>
      </div>
    </div>
  );

  const renderYogaStep3 = () => (
    <div className="row g-3">
      <h2
        className="text-center text-white p-2"
        style={{ backgroundColor: "#01AEBE" }}
      >
        Examination
      </h2>
      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Height (cm)</label>
        <input
          type="number"
          name="height_cm"
          className={getFieldClass("height_cm")}
          placeholder="Enter Height in cm"
          value={addData.height_cm}
          onChange={handleInputChange}
          step="0.1"
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Weight (kg)</label>
        <input
          type="number"
          name="weight_kg"
          className={getFieldClass("weight_kg")}
          placeholder="Enter Weight in kg"
          value={addData.weight_kg}
          onChange={handleInputChange}
          step="0.1"
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Blood Group</label>
        <select
          name="blood_group"
          className={getSelectClass("blood_group")}
          value={addData.blood_group}
          onChange={handleInputChange}
        >
          <option value="">Select Blood Group</option>
          <option value="A+">A+</option>
          <option value="A-">A-</option>
          <option value="B+">B+</option>
          <option value="B-">B-</option>
          <option value="AB+">AB+</option>
          <option value="AB-">AB-</option>
          <option value="O+">O+</option>
          <option value="O-">O-</option>
        </select>
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">BP Level</label>
        <input
          type="text"
          name="bp_level"
          className={getFieldClass("bp_level")}
          placeholder="Enter BP Level"
          value={addData.bp_level}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Sugar Level</label>
        <input
          type="text"
          name="sugar_level"
          className={getFieldClass("sugar_level")}
          placeholder="Enter Sugar Level"
          value={addData.sugar_level}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Pulse</label>
        <input
          type="text"
          name="pluse"
          className={getFieldClass("pluse")}
          placeholder="Enter Pulse"
          value={addData.pluse}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Breast</label>
        <input
          type="text"
          name="breast"
          className={getFieldClass("breast")}
          placeholder="Enter Breast Exam Details"
          value={addData.breast}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Thyroid</label>
        <input
          type="text"
          name="tyroid"
          className={getFieldClass("tyroid")}
          placeholder="Enter Thyroid Exam Details"
          value={addData.tyroid}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Per Abdomen</label>
        <input
          type="text"
          name="per_abutamon"
          className={getFieldClass("per_abutamon")}
          placeholder="Enter Per Abdomen Details"
          value={addData.per_abutamon}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Per Speculum</label>
        <input
          type="text"
          name="per_speculum"
          className={getFieldClass("per_speculum")}
          placeholder="Enter Per Speculum Details"
          value={addData.per_speculum}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Per Vaginal Exam</label>
        <input
          type="text"
          name="per_virginal_exam"
          className={getFieldClass("per_virginal_exam")}
          placeholder="Enter Per Vaginal Exam Details"
          value={addData.per_virginal_exam}
          onChange={handleInputChange}
        />
      </div>

      <div className="text-center mt-4">
        <button
          type="button"
          className="btn btn-secondary me-3 px-4 py-2"
          onClick={handleBack}
        >
          Back
        </button>
        <button
          type="button"
          className="btn btn-info text-white fw-semibold px-4 py-2"
          style={{ backgroundColor: "#01AEBE" }}
          onClick={handleNext}
        >
          Next
        </button>
      </div>
    </div>
  );

  const renderYogaStep5 = () => (
    <div className="row g-3">
      <h2
        className="text-center text-white p-2"
        style={{ backgroundColor: "#01AEBE" }}
      >
        Diagnosis
      </h2>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Diagnosis</label>
        <textarea
          name="diagonsis"
          className={getFieldClass("diagonsis")}
          placeholder="Enter Diagnosis"
          rows="3"
          value={addData.diagonsis}
          onChange={handleInputChange}
        ></textarea>
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Plan of Treatment</label>
        <textarea
          name="plan_of_treatment"
          className={getFieldClass("plan_of_treatment")}
          placeholder="Enter Plan of Treatment"
          rows="3"
          value={addData.plan_of_treatment}
          onChange={handleInputChange}
        ></textarea>
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Advice</label>
        <textarea
          name="advise"
          className={getFieldClass("advise")}
          placeholder="Enter Advice"
          rows="3"
          value={addData.advise}
          onChange={handleInputChange}
        ></textarea>
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Scan Findings</label>
        <textarea
          name="scan_findings"
          className={getFieldClass("scan_findings")}
          placeholder="Enter Scan Findings"
          rows="3"
          value={addData.scan_findings}
          onChange={handleInputChange}
        ></textarea>
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Next Review Date</label>
        <input
          type="date"
          name="next_review_date"
          className={getFieldClass("next_review_date")}
          value={addData.next_review_date}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Semen Analysis</label>
        <textarea
          name="siemen_analysis"
          className={getFieldClass("siemen_analysis")}
          placeholder="Enter Semen Analysis"
          rows="3"
          value={addData.siemen_analysis}
          onChange={handleInputChange}
        ></textarea>
      </div>

      <div className="text-center mt-4">
        <button
          type="button"
          className="btn btn-secondary me-3 px-4 py-2"
          onClick={handleBack}
        >
          Back
        </button>
        <button
          type="button"
          className="btn btn-info text-white fw-semibold px-4 py-2"
          style={{ backgroundColor: "#01AEBE" }}
          onClick={handleSubmit}
        >
          Update
        </button>
      </div>
    </div>
  );

  const renderHomeopathyStep2 = () => (
    <div className="row g-3">
      <h2
        className="text-center text-white p-2"
        style={{ backgroundColor: "#01AEBE" }}
      >
        Homeopathy
      </h2>
      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Blood Pressure</label>
        <input
          type="text"
          name="homeo_bp"
          className={getFieldClass("homeo_bp")}
          placeholder="Enter BP"
          value={addData.homeo_bp}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Sugar</label>
        <input
          type="text"
          name="homeo_sugar"
          className={getFieldClass("homeo_sugar")}
          placeholder="Enter Sugar"
          value={addData.homeo_sugar}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Height</label>
        <input
          type="number"
          name="homeo_height"
          className={getFieldClass("homeo_height")}
          placeholder="Enter Height"
          value={addData.homeo_height}
          onChange={handleInputChange}
          step="0.1"
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Heart Rate</label>
        <input
          type="text"
          name="homeo_heart_rate"
          className={getFieldClass("homeo_heart_rate")}
          placeholder="Enter Heart Rate"
          value={addData.homeo_heart_rate}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Blood Test</label>
        <input
          type="text"
          name="homeo_blood_test"
          className={getFieldClass("homeo_blood_test")}
          placeholder="Enter Blood Test Details"
          value={addData.homeo_blood_test}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Electrohomeogram</label>
        <input
          type="text"
          name="homeo_electriohomeogram"
          className={getFieldClass("homeo_electriohomeogram")}
          placeholder="Enter ECG Details"
          value={addData.homeo_electriohomeogram}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Stress Test</label>
        <input
          type="text"
          name="homeo_stress_test"
          className={getFieldClass("homeo_stress_test")}
          placeholder="Enter Stress Test Details"
          value={addData.homeo_stress_test}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Echohomeogram</label>
        <input
          type="text"
          name="homeo_echohomeogram"
          className={getFieldClass("homeo_echohomeogram")}
          placeholder="Enter Echohomeogram Details"
          value={addData.homeo_echohomeogram}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-4">
        <label className="form-label fw-semibold">Scan Type</label>
        <input
          type="text"
          name="homeo_scan_type"
          className={getFieldClass("homeo_scan_type")}
          placeholder="Enter Scan Type"
          value={addData.homeo_scan_type}
          onChange={handleInputChange}
        />
      </div>

      <div className="text-center mt-4">
        <button
          type="button"
          className="btn btn-secondary me-3 px-4 py-2"
          onClick={handleBack}
        >
          Back
        </button>
        <button
          type="button"
          className="btn btn-info text-white fw-semibold px-4 py-2"
          style={{ backgroundColor: "#01AEBE" }}
          onClick={handleSubmit}
        >
          Update
        </button>
      </div>
    </div>
  );

  return (
    <div className="p-2">
      <div className="card w-100 p-2">
        {errors.submit && (
          <div className="alert alert-danger" role="alert">
            {errors.submit}
          </div>
        )}
        {currentPage === 1 && renderStep1()}
        {patientType === "Yoga" &&
          currentPage === 2 &&
          renderYogaStep2()}
        {patientType === "Yoga" &&
          currentPage === 3 &&
          renderYogaStep3()}
        {patientType === "Yoga" &&
          currentPage === 4 &&
          renderYogaStep5()}
        {patientType === "Homeopathy" &&
          currentPage === 2 &&
          renderHomeopathyStep2()}
      </div>
    </div>
  );
}

export default UpdatePatients;
